import React from 'react';
import { Outlet } from 'react-router-dom';

type Props = {};

const ReminderPageLayout = (props: Props) => {
  return (
    <><Outlet /></>
  );
};

export default ReminderPageLayout;